import styled from 'styled-components';
/* menggunakan plugin styled-components
buttonContainer adalah nama tag yang akan kita gunakan untuk menerapkan stylenya
Gunakan 'export agar dapat digunakan di semua file' */
export const ButtonContainer = styled.button`
    text-transform: capitalize;
    font-size : 1.4rem;
    background:transparent;
    outline: none;
    border: none;
`;